import { type InsuranceCorporateIdentity } from "../types";

export function EWELogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <clipPath id="clip0_35_9752">
          <rect
            width="348"
            height="384"
            fill="white"
            transform="translate(82 65)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clip0_35_9752)">
        <path
          d="M430 257.012C430 363.043 344.185 449 238.309 449C211.619 449 186.231 443.532 163.15 433.656C178.3 437.695 194.211 439.887 210.637 439.887C312.339 439.887 395.183 358.856 395.183 257.012C395.183 155.144 312.314 71.0343 210.637 71.0343C201.38 71.0343 192.271 71.7485 183.358 73.0539C200.766 67.8324 219.206 65 238.309 65C344.185 65.0246 430 150.982 430 257.012Z"
          fill="#FFD500"
        />
        <path
          d="M290.805 239.575C290.805 297.405 244.055 344.3 186.402 344.3C128.75 344.3 82 297.405 82 239.575C82 181.744 128.75 134.85 186.402 134.85C244.055 134.85 290.805 181.72 290.805 239.575ZM256.233 239.575C256.233 200.881 224.952 169.528 186.402 169.528C147.829 169.528 116.572 200.881 116.572 239.575C116.572 278.268 147.853 309.621 186.402 309.621C224.976 309.621 256.233 278.268 256.233 239.575Z"
          fill="#FFD500"
        />
        <path
          d="M360.415 256.938C360.415 179.404 301.903 115.614 226.793 107.609C284.151 124.85 325.966 178.222 325.966 241.446C325.966 318.611 263.673 381.145 186.795 381.145C144.98 381.145 107.511 362.599 82 333.29C108.052 377.476 155.956 407.13 210.809 407.13C293.432 407.13 360.415 339.891 360.415 256.938Z"
          fill="#FFD500"
        />
      </g>
    </svg>
  );
}

export const EWE: InsuranceCorporateIdentity = {
  id: "ewe",
  name: "EWE BKK",
  logo: EWELogo,
  backgroundColor: "#014694",
  textColor: "#FFFFFF",
  wildcard: "ewe",
  type: "statutory",
};
